import React from "react"
import { I18nextProvider } from "react-i18next"

import i18next from "./i18next"

const I18nProvider = (props) => <I18nextProvider i18n={i18next} {...props} />

export { I18nProvider }
